import React from "react";
import { motion } from "framer-motion";
/* img imports */
import cloud1 from "../assets/images/clouds/cloud-1.png";
import cloud2 from "../assets/images/clouds/cloud-2.png";

/* anime import */
import { cloudMoveAnime1, cloudMoveAnime2 } from "../assets/js/animations";

const Clouds = () => {
  return (
    <>
      <motion.div
        className="cloud-1-wrapper"
        variants={cloudMoveAnime1}
        initial="initial"
        animate="animate"
      >
        <img src={cloud1} alt="" />
      </motion.div>
      <motion.div
        className="cloud-2-wrapper"
        variants={cloudMoveAnime2}
        initial="initial"
        animate="animate"
      >
        <img src={cloud2} alt="" />
      </motion.div>
    </>
  );
};

export default Clouds;
